export default "__VITE_ASSET__9c3bc4a4__"